<template>
    <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary shadow border-0">
              <div v-if="loggedIn" class="card-header bg-transparent pt-5 pb-5">
                  <div class="text-center mt-2 mb-3">Paysly is <a target="_blank" href="https://docs.paysly.io/overview.html"> powered by stripe</a>. Connect your stripe account to get started!</div>
              </div>
              <div class="card-body px-lg-5 py-lg-5">
                  <span v-if="!loggedIn" >
                    <div id="firebaseui-auth-container"/>
                    <div class="text-center mt-5">By logging in, you agree to our
                      <router-link to="/privacy">Privacy Policy</router-link>
                       and
                      <router-link to="/tos">Terms of Use</router-link>.
                    </div>
                  </span>
                  <div v-else>
                    <img @click="auth" style="cursor:pointer;width:100%" src="/img/stripe/connect.png"/>
                  </div>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
  import firebase from '../firebase';
  import * as firebaseui from 'firebaseui';
  import { mapGetters } from 'vuex';


  const startUi = function startUi(ui) {
    ui.start('#firebaseui-auth-container', {
      signInOptions: [
        // List of OAuth providers supported.
        {
          provider: firebase.instance.auth.EmailAuthProvider.PROVIDER_ID,
          requireDisplayName: false,
        },
        firebase.instance.auth.GithubAuthProvider.PROVIDER_ID,
        firebase.instance.auth.GoogleAuthProvider.PROVIDER_ID,
      ],
      credentialHelper: firebaseui.auth.CredentialHelper.NONE,
      signInFlow: 'popup',
      autoUpgradeAnonymousUsers: true,
      callbacks: {
        signInSuccessWithAuthResult() {},
        // signInFailure callback must be provided to handle merge conflicts which
        // occur when an existing credential is linked to an anonymous user.
        signInFailure(error) {
          // For merge conflicts, the error.code will be
          // 'firebaseui/anonymous-upgrade-merge-conflict'.
          if (error.code !== 'firebaseui/anonymous-upgrade-merge-conflict') {
            return Promise.resolve();
          }
          // The credential the user tried to sign in with.
          const cred = error.credential;
          // Should we copy existing anon data, or just swap to attempted cred? lets opt for the
          // latter for now.
          return firebase.instance.auth().signInAndRetrieveDataWithCredential(cred);
        },
      },
    });
  };

  export default {
    name: 'login',
    computed: {
      ...mapGetters([
        'loggedIn',
      ]),
    },
    methods: {
      auth() {
        window.location.href = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${process.env.VUE_APP_STRIPE_CLIENT_ID}&scope=read_write`;
      }
    },
    mounted() {
      startUi(window.authui);
    },
  }
</script>
<style>
</style>
